/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class ImportWAProductDialog extends NoboxEntityDialog<ProductsRow, any> {
        protected getFormKey() { return ImportWAProductForm.formKey; }
        public clickAutoRefresh = () => { }
        protected form = new ImportWAProductForm(this.idPrefix);
        constructor() {
            super();
        }

        updateTitle() {
            this.dialogTitle = "Import WhatsApp Products"
        }

        protected getToolbarButtons() {
            return [];
        }

        getDialogButtons() {
            var buttons = [] as Serenity.DialogButton[];
            buttons.push({
                text: "Import",
                cssClass: "bg-primary",
                click: () => {
                    if (this.validateForm()) {
                        ProductsService.RequestWAProduct({
                            EntityId: this.form.AccountIds.value,
                        }, (res) => {
                            Q.information(`Success request import Whatsapp product in account '${this.form.AccountIds.text}', please wait until product imported to your account`, () => {
                                this.clickAutoRefresh();
                            });
                            this.dialogClose();
                        })
                    }
                }
            });
            buttons.push({
                text: "Cancel",
                click: () => {
                    this.dialogClose();
                }
            });
            return buttons;
        }
    }
}